module.exports = __webpack_public_path__ + "static/img/banner2.ecfef8a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/banner2.svg
// module id = Q77N
// module chunks = 1